/* ==========================================================================
   Kidea Busy Book page: colour picker, per-book colours, bundle tiers, add-on,
   add to cart (button shows the chosen bundle's price), sticky buy bar and the
   lazy video. Prices are never formatted here: every amount is a string Liquid
   rendered with sg-price into a data attribute. Gallery, accordions, reviews
   and reveal come from kidea.js.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-bb]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Lazy video ---------- */
  qsa('[data-bb-video]').forEach(function (v) {
    function load() {
      if (v.getAttribute('src')) return;
      v.src = v.getAttribute('data-src');
      if (reduced) { v.controls = true; v.loop = false; return; }
      v.autoplay = true;
      var p = v.play(); if (p && p.catch) p.catch(function () { v.controls = true; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { load(); if (!reduced && v.paused && v.src) v.play().catch(function () {}); }
          else if (v.src && !v.paused) v.pause();
        });
      }, { rootMargin: '200px 0px' });
      io.observe(v);
    } else load();
  });

  if (!root) return;
  var bundle = qs('[data-bb-bundle]', root);
  var tiers = qsa('[data-bb-tier]', root);
  var colors = qsa('[data-bb-color]', root);
  var colorName = qs('[data-bb-color-name]', root);
  var addon = qs('[data-bb-addon]', root);
  var atc = qs('[data-bb-add]', root);
  var atcPrice = qs('[data-bb-atc-price]', root);
  var saveAmt = qs('[data-bb-save-amt]', root);
  var saveRow = qs('[data-bb-save]', root);
  var bar = qs('[data-bb-sticky]', root);
  var barTier = qs('[data-bb-sticky-tier]', root);
  var barTotal = qs('[data-bb-sticky-total]', root);
  var barBtn = qs('[data-bb-sticky-add]', root);
  var gal = qs('[data-gallery]', root);
  var active = qs('[data-bb-color].is-active', root);
  var mainVariant = active ? active.getAttribute('data-variant') : null;
  if (!mainVariant) {
    try { mainVariant = String(JSON.parse(qs('[data-bb-default]', root).textContent).variant); } catch (e) {}
  }
  if (!mainVariant && atc) mainVariant = atc.getAttribute('data-variant');

  function current() { return qs('[data-bb-tier].is-selected', root) || tiers[0]; }

  function update() {
    var t = current();
    if (!t) return;
    var withAdd = addon && addon.checked;
    var total = t.getAttribute(withAdd ? 'data-total-add-money' : 'data-total-money');
    var save = t.getAttribute(withAdd ? 'data-save-add-money' : 'data-save-money');
    if (atcPrice) {
      if (reduced) atcPrice.textContent = total;
      else {
        atc.classList.add('is-swap');
        setTimeout(function () { atcPrice.textContent = total; atc.classList.remove('is-swap'); }, 120);
      }
    }
    if (saveAmt) saveAmt.textContent = save;
    if (saveRow) saveRow.hidden = !save;
    if (barTotal) barTotal.textContent = total;
    if (barTier) barTier.textContent = t.getAttribute('data-name');
  }

  function selectTier(t) {
    tiers.forEach(function (x) {
      var on = x === t;
      x.classList.toggle('is-selected', on);
      var b = qs('[data-bb-tier-btn]', x);
      if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    update();
  }

  function setUnit(unitEl, variant) {
    qsa('[data-bb-uopt]', unitEl).forEach(function (b) {
      var on = b.getAttribute('data-variant') === String(variant);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function chooseColor(btn) {
    mainVariant = btn.getAttribute('data-variant');
    colors.forEach(function (c) {
      var on = c === btn;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (colorName) colorName.textContent = btn.getAttribute('data-name');
    // Every book follows the main colour until the customer mixes them.
    qsa('[data-bb-unit]', root).forEach(function (u) { setUnit(u, mainVariant); });
    var to = parseInt(btn.getAttribute('data-slide-to'), 10);
    var th = gal && qs('[data-thumb="' + to + '"]', gal);
    if (th) th.click();
  }

  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-bb-color]');
    if (c && !c.disabled) { chooseColor(c); return; }
    var head = e.target.closest('[data-bb-tier-btn]');
    if (head) { selectTier(head.closest('[data-bb-tier]')); return; }
    var u = e.target.closest('[data-bb-uopt]');
    if (u && !u.disabled) {
      var unit = u.closest('[data-bb-unit]');
      setUnit(unit, u.getAttribute('data-variant'));
      if (unit.getAttribute('data-bb-unit') === '1') {
        var match = qs('[data-bb-color][data-variant="' + u.getAttribute('data-variant') + '"]', root);
        if (match) {
          mainVariant = u.getAttribute('data-variant');
          colors.forEach(function (x) { x.classList.toggle('is-active', x === match); x.setAttribute('aria-pressed', x === match ? 'true' : 'false'); });
          if (colorName) colorName.textContent = match.getAttribute('data-name');
        }
      }
      return;
    }
  });
  if (addon) addon.addEventListener('change', function () {
    var row = addon.closest('.k-addon-row');
    if (row) row.classList.toggle('is-on', addon.checked);
    update();
  });

  function items() {
    var t = current();
    var n = parseInt(t.getAttribute('data-units'), 10) || 1;
    var counts = {};
    var units = qsa('[data-bb-unit]', t);
    if (n > 1 && units.length) {
      units.slice(0, n).forEach(function (u) {
        var a = qs('[data-bb-uopt].is-active', u);
        var id = a ? a.getAttribute('data-variant') : mainVariant;
        counts[id] = (counts[id] || 0) + 1;
      });
    } else {
      counts[mainVariant] = n;
    }
    var list = Object.keys(counts).filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    if (addon && addon.checked) list.push({ id: parseInt(addon.getAttribute('data-variant'), 10), quantity: 1 });
    return list;
  }

  function add(btn) {
    var list = items();
    if (!list.length) return;
    if (window.KideaAddToCart) { window.KideaAddToCart(list, btn, { upsell: false }); return; }
    btn.disabled = true;
    var rootUrl = (window.Kidea && window.Kidea.routes && window.Kidea.routes.root) || '/';
    if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: list })
    }).then(function () { window.location.href = rootUrl + 'cart'; })
      .catch(function () { btn.disabled = false; });
  }
  if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); add(atc); });
  if (barBtn) barBtn.addEventListener('click', function (e) { e.preventDefault(); add(barBtn); });

  /* ---------- Sticky bar: slides in once the main button has scrolled away ---------- */
  if (bar && atc) {
    var ticking = false;
    var header = qs('.k-header-section');
    var footer = qs('.k-footer');
    function place() {
      ticking = false;
      var hh = header ? header.getBoundingClientRect().height : 0;
      var past = atc.getBoundingClientRect().bottom < hh;
      var atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight - 40;
      var on = past && !atFooter;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('has-sticky', on);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
    window.addEventListener('resize', place);
    place();
  }

  update();
})();
